// Role-based permission system for Venture Hills

export type AdminRole = 'super_admin' | 'team_admin' | 'member';

export interface RolePermissions {
  command_center: string[];
  can_edit_clients: boolean;
  can_view_revenue: boolean;
  can_manage_roles: boolean;
  show_all_navigation: boolean;
  allowed_pages?: string[];
}

export const PERMISSIONS: Record<AdminRole, RolePermissions> = {
  super_admin: {
    command_center: ['client_registry', 'client_integrations', 'payment_methods', 'fanbasis_setup'],
    can_edit_clients: true,
    can_view_revenue: true,
    can_manage_roles: true,
    show_all_navigation: true
  },
  team_admin: {
    command_center: ['client_registry', 'client_integrations'],
    can_edit_clients: true,
    can_view_revenue: false,
    can_manage_roles: false,
    show_all_navigation: true
  },
  member: {
    command_center: ['client_registry'],
    can_edit_clients: false,
    can_view_revenue: false,
    can_manage_roles: false,
    show_all_navigation: false,
    allowed_pages: ['/admin/command-center', '/admin/onboarding', '/admin/support-tickets', '/admin/dashboards']
  }
};

export function getPermissions(role: string): RolePermissions {
  return PERMISSIONS[role as AdminRole] || PERMISSIONS.member;
}

export function canAccessTab(role: string, tab: string): boolean {
  const perms = getPermissions(role);
  return perms.command_center?.includes(tab) || false;
}

export function canAccessPage(role: string, path: string): boolean {
  const perms = getPermissions(role);
  if (perms.show_all_navigation) return true;
  return perms.allowed_pages?.some(p => path.startsWith(p)) || false;
}

export function canEditClients(role: string): boolean {
  return getPermissions(role).can_edit_clients;
}

export function canViewRevenue(role: string): boolean {
  return getPermissions(role).can_view_revenue;
}

export function canManageRoles(role: string): boolean {
  return getPermissions(role).can_manage_roles;
}
